module.exports = __webpack_public_path__ + "img/berget-logo-26.2fb06d72.png";